import type { LocalizedDict } from '../index'

// Settings → Organization, real-engine view (RealOrganization.tsx).
export type RealOrganizationStrings = {
  pageTitle: string
  pageDescription: string
  orgIdLabel: string
  copyOrgId: string
  copyFailed: string
  copied: string
  loading: string
  noOrgTitle: string
  noOrgBody: string
  loadError: (error: string) => string
  platformRecord: string
  fields: {
    name: string
    slug: string
    orgType: string
    status: string
    created: string
    updated: string
  }
  // Status values come from the API; en shows them exactly as sent.
  statusLabels: Record<'active' | 'suspended' | 'deleted', string>
  footer: string
}

export const realOrganizationI18n: LocalizedDict<RealOrganizationStrings> = {
  en: {
    pageTitle: 'Organization',
    pageDescription: 'Your organization profile as recorded on the platform.',
    orgIdLabel: 'Organization ID',
    copyOrgId: 'Copy organization ID',
    copyFailed: 'Copy failed — select the ID and copy it by hand.',
    copied: 'Copied',
    loading: 'Loading organization…',
    noOrgTitle: 'No active organization',
    noOrgBody: 'Your account is not currently attached to an organization.',
    loadError: (error) => `Could not load organization: ${error}`,
    platformRecord: 'Platform-owned organization record.',
    fields: {
      name: 'Name',
      slug: 'Slug',
      orgType: 'Org type',
      status: 'Status',
      created: 'Created',
      updated: 'Updated',
    },
    statusLabels: {
      active: 'active',
      suspended: 'suspended',
      deleted: 'deleted',
    },
    footer:
      'Read-only profile. Business details, contact, and address fields are not yet captured by the backend.',
  },
  tr: {
    pageTitle: 'Organizasyon',
    pageDescription: 'Organizasyonunun platformda kayıtlı profili.',
    orgIdLabel: 'Organizasyon kimliği',
    copyOrgId: 'Organizasyon kimliğini kopyala',
    copyFailed: 'Kopyalanamadı — kimliği seçip elle kopyala.',
    copied: 'Kopyalandı',
    loading: 'Organizasyon yükleniyor…',
    noOrgTitle: 'Aktif organizasyon yok',
    noOrgBody: 'Hesabın şu anda bir organizasyona bağlı değil.',
    loadError: (error) => `Organizasyon yüklenemedi: ${error}`,
    platformRecord: 'Platformda tutulan organizasyon kaydı.',
    fields: {
      name: 'Ad',
      slug: 'Kısa ad',
      orgType: 'Organizasyon türü',
      status: 'Durum',
      created: 'Oluşturulma',
      updated: 'Güncellenme',
    },
    statusLabels: {
      active: 'aktif',
      suspended: 'askıda',
      deleted: 'silindi',
    },
    footer:
      'Salt okunur profil. İş bilgileri, iletişim ve adres alanları henüz sistemde tutulmuyor.',
  },
}
